import Layout from './components/Layout';
import GlobalStyles from './styles/GlobalStyles';

function App() {
  return (
    <>
      <Layout />
      <GlobalStyles />
    </>
  );
}

export default App;
